import { render, staticRenderFns } from "./copyInfoPage.vue?vue&type=template&id=767cd32e&scoped=true"
import script from "./copyInfoPage.vue?vue&type=script&lang=js"
export * from "./copyInfoPage.vue?vue&type=script&lang=js"
import style0 from "./copyInfoPage.vue?vue&type=style&index=0&id=767cd32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767cd32e",
  null
  
)

export default component.exports